import Player from "@vimeo/player";

const videoReferences = document.querySelectorAll(".js-bg-video[data-videoid]");

let videosReady = 0,
    bgVideoArray = [];

export function init() {
    if (!videoReferences.length) {
        return false;
    }

    // Get all the videos ready
    load();
}

function load() {
    let t;

    [...videoReferences].forEach((el, i) => {
        let videoId = el.dataset.videoid ? el.dataset.videoid : i.toString(),
            video = document.createElement("div"),
            youtubePlayer,
            vimeoPlayer;

        //  Add unique ID to this video element
        video.id = "video_" + videoId;

        // Save video DOM element as child of video reference element
        el.appendChild(video);

        if (!isNaN(parseFloat(videoId)) && isFinite(videoId)) {
            vimeoPlayer = new Player(video, {
                id: videoId,
                width: 1920,
                playsinline: true,
                loop: true,
                muted: true,
                autoplay: true,
                background: true,
                controls: false,
                title: false,
                byline: false,
            });

            vimeoPlayer.ready().then(videoPlayerReady());
        } else {
            // YouTube player
            youtubePlayer = new YT.Player(video, {
                width: "1920",
                height: "1080",
                videoId: videoId,
                playerVars: {
                    autoplay: 1,
                    playsinline: 1,
                    loop: 1,
                    mute: 1,
                    controls: 0,
                    fs: 0,
                    modestbranding: 1,
                    showinfo: 0,
                    disabledkb: 1,
                    rel: 0,
                    playlist: videoId,
                },
                events: {
                    onReady: videoPlayerReady,
                },
            });
        }

        bgVideoArray.push({
            videoId: videoId,
            vimeoPlayer: vimeoPlayer,
            youtubePlayer: youtubePlayer,
        });
    });

    // When all the videos are 'ready', size them
    t = setInterval(function () {
        if (videosReady === videoReferences.length) {
            clearInterval(t);

            // Fix video dimensions based on container dimensions
            window.addEventListener("resize", fitVideos);
            fitVideos();
        }
    }, 500);
}

function fitVideos() {
    console.log("fitVideos");
    // List of Video Vendors embeds you want to support
    const players = [
        '.js-bg-video iframe[src*="youtube.com"]',
        '.js-bg-video iframe[src*="vimeo.com"]',
    ];

    const fitVids = document.querySelectorAll(players.join(","));

    // If there are videos on the page...
    if (fitVids.length) {
        // Loop through videos
        for (var i = 0; i < fitVids.length; i++) {
            // Get Video Information
            const fitVid = fitVids[i],
                width = fitVid.getAttribute("width"),
                height = fitVid.getAttribute("height"),
                videoAspectRatio = height / width,
                parentDiv = fitVid.closest(".js-bg-video"),
                parentDimensions = parentDiv.getBoundingClientRect(),
                parentAspectRatio =
                    parentDimensions.height / parentDimensions.width;
            
            if (parentAspectRatio > videoAspectRatio) {
                fitVid.style.width = `${
                    parentDimensions.width / videoAspectRatio
                }px`;
                fitVid.style.height = `100%`;
                fitVid.style.left = `50%`;
                fitVid.style.top = `0`;
                fitVid.style.transform = `translateX(-50%)`;
            } else {
                fitVid.style.height = `${
                    videoAspectRatio * parentDimensions.width
                }px`;
                fitVid.style.width = `100%`;
                fitVid.style.left = `0`;
                fitVid.style.top = `50%`;
                fitVid.style.transform = `translateY(-50%)`;
            }

            parentDiv.classList.remove("opacity-0");
        }
    }
}

function videoPlayerReady() {
    videosReady++;
}
